"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var useConstructor = function (callback) {
    var hasBeenCalled = React.useRef(false);
    if (hasBeenCalled.current)
        return;
    callback === null || callback === void 0 ? void 0 : callback();
    hasBeenCalled.current = true;
};
exports.default = useConstructor;
